import { Head, Link, router } from '@inertiajs/react'
import Layout from '../../components/Layout'
import { BillingStatusBadge } from '../../components/billing/BillingUI'
import { BillingPresentationNotices, billingAction, type BillingPresentation } from '../../components/billing/BillingPresentation'
import { BillingReturnNotice, type CheckoutFeedback } from '../../components/billing/BillingFeedback'
import type { BillingSubscription } from '../../types'

interface Props {
  subscription: BillingSubscription | null
  presentation: BillingPresentation
  checkout_path: string
  payer_switch_checkout_path: string
  portal_path: string | null
  checkout_feedback?: CheckoutFeedback | null
}

export default function AdminBilling({ subscription, presentation, checkout_path, payer_switch_checkout_path, portal_path, checkout_feedback }: Props) {
  return <Layout>
    <Head title="Billing - Pinnacle" />
    <div className="max-w-4xl mx-auto space-y-6">
      <div><h1 className="text-3xl font-bold text-text-primary font-heading">Company billing</h1><p className="text-text-muted mt-1">View your plan, renewal, and payment setup.</p></div>
      <BillingReturnNotice feedback={checkout_feedback} />
      <BillingPresentationNotices presentation={presentation} />
      <div className="flex gap-3">
        {billingAction(presentation, 'checkout') && <button onClick={() => router.post(checkout_path)} className="px-4 py-2 rounded-lg bg-pinnacle-red text-white">Enter card securely</button>}
        {billingAction(presentation, 'resume_switch') && <button onClick={() => router.post(payer_switch_checkout_path)} className="px-4 py-2 rounded-lg bg-pinnacle-red text-white">Enter company card</button>}
      </div>
      {subscription && <section className="bg-white rounded-xl border border-stone/20 shadow-card p-6 space-y-5">
        <div className="flex justify-between"><div><p className="text-xs uppercase text-text-muted">Selected plan</p><h2 className="text-2xl font-bold">{subscription.plan.name}</h2><p>{subscription.plan.price_display}</p></div><BillingStatusBadge status={subscription.status} detail={subscription.status_detail} /></div>
        <p>Selected payer: {subscription.payer === 'company' ? 'Your company' : 'Your Guide'}</p>
        <p>{subscription.trial_ends_display ? `Trial ends: ${subscription.trial_ends_display}` : `Next charge: ${subscription.next_charge_display || 'Not scheduled'}`}</p>
        {subscription.payer === 'company' ? <div className="space-y-3">
          <h2 className="text-lg font-bold">Payment and invoices</h2><p>{subscription.payment_method_display || 'No payment method saved'}</p>
          {portal_path && billingAction(presentation, 'portal') && <button onClick={() => router.post(portal_path)} className="underline font-semibold">Manage in Stripe</button>}
          {subscription.invoices?.map(invoice => invoice.hosted_url && <a key={invoice.id} href={invoice.hosted_url} target="_blank" rel="noreferrer" className="block text-pinnacle-red">View latest invoice in Stripe ↗</a>)}
        </div> : <p>Pricing, invoices, cards, and payment controls are private to the responsible payer.</p>}
      </section>}
      <Link href="/admin/settings" className="text-sm text-text-muted">← Back to settings</Link>
    </div>
  </Layout>
}